import { IGetItemsParams } from '../types/IGetItemsParams';
import { IGetItemsResult } from '../types/IGetItemsResult';
import { IPublishedConnection } from '../types/IPublishedConnection';
import { IUser } from '../types/IUser';
import { INamedItem } from '../types/resourceParts';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IGetPublishedConnectionsParams extends IGetItemsParams {
}

export interface IGetPublishedConnectionsResult extends IGetItemsResult {
  publishedConnections?: IPublishedConnection[];
  users?: IUser[];
  projects?: INamedItem[];
  favorites?: string[];
}

export class GetPublishedConnectionsRequest extends Request<IGetPublishedConnectionsParams, IGetPublishedConnectionsResult> {
  constructor(params: IGetPublishedConnectionsParams) {
    super('getPublishedConnections', params);
  }
}
